export interface Ratings {
  average: number;
  count: number;
}

export const getRatingAverage = (ratings: Ratings[]): Ratings => {
  const countsCombined = ratings.reduce((prev, item) => prev + item.count, 0);

  if (!countsCombined) {
    return { average: 0, count: 0 };
  }

  const weightsCombined = ratings.reduce(
    (prev, item) => prev + item.count * item.average,
    0,
  );

  return {
    average: weightsCombined / countsCombined,
    count: countsCombined,
  };
};
